/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import { getMultiSampleState } from 'cards/selectors/singlesample';
import { useMobileCheck } from '../util/hooks';
import styles from './styles.module.less';

const ToggleLabelBase = ({ multiSampleState }) => {
  const isMobile = useMobileCheck();

  if (isMobile) {
    return null;
  }

  let labelText;

  if (multiSampleState.enabled) {
    const { limit } = multiSampleState.count;

    labelText = `Pick ${limit} Free Sample${limit === 1 ? '' : 's'}`;
  } else {
    labelText = 'Pick Free Sample Designs';
  }

  return <div className={styles.toggleLabelBox}>{labelText}</div>;
};

export const mapStateToProps = state => ({
  multiSampleState: getMultiSampleState(state),
});

export default connect(mapStateToProps)(ToggleLabelBase);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/MultiSample/ToggleLabel.jsx